import utiles from "@/modules/Shared/utiles/utiles";
import store from "@/store";
import axios from "axios";

export default class CategoriaService {
    constructor() {
        this.axios = axios.create({
            baseURL: utiles.state.api,
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + store.state.user.token
            }
        });
        store.watch(
            (state) => state.user,
            (newUser) => {
              this.axios.defaults.headers.Authorization = `Bearer ${newUser.token}`;
            }
          );
    }


    async getAll(params) {
        console.log(params)
        const response = await this.axios.get('categoria', {params: params});
        return response.data;
    }

    async createCategoria(data) {
        const response = await this.axios.post('categoria', data, { headers: { 'Content-Type': "application/json" }});
        return response.data;
    }

    async updateCategoria(data) {
        const response = await this.axios.put('categoria', data);
        return response.data;
    }

    async deleteCategoria(idcategoria) {
        const response = await this.axios.delete('categoria?idcategoria=' + idcategoria)
        return response.data;
    }
}